import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r752r7dbs: FaireProductEntity = {
  token: "p_2r752r7dbs",
  type: "product",
  name: "Tallow Lip Balm",
  brandToken: "b_p8ncnjxwk2",
  brandName: "Pure Good",
  imageUrl:
    "https://cdn.faire.com/fastly/9b925c3f587330efdcb46395ced65bdb452a176e2c682a2c0680e590453f11c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/531b70290cfa5ef1d8b7fe3fceb95a1873246423d5eb0345ee009cad9d36e5d4.jpeg",
    "https://cdn.faire.com/fastly/4975dbdfb34a1b811c1b5f3bef190aadf0008ff1a5f9f70e45dd6b1e05ebc7e7.jpeg",
    "https://cdn.faire.com/fastly/ce54e7620af63923a1f27471697413e76c3155290b87d587e4b322738ca1913f.jpeg",
    "https://cdn.faire.com/fastly/232891666b8ad5fff7e56addd9708bbcf1adf7882f80601f2c3e637fc79fce6e.jpeg",
    "https://cdn.faire.com/fastly/4b5ef8c69321d78fe601ae1d47c78479f1b0769ffe103774bd325303a8407213.jpeg",
    "https://cdn.faire.com/fastly/2858bbe1f3b455869de3b5c57a52218504c7db4a85b6d4d2e6a1dda3996836e1.jpeg",
    "https://cdn.faire.com/fastly/a7e64cdf7fd324f1789618668179d2504a12b802485b7d10d9f9f6c1ce9517b4.jpeg",
    "https://cdn.faire.com/fastly/222c747c4255af23dd19bd0bca30f40b69da9f00fecddcfac38a9c349bc7e90c.jpeg",
    "https://cdn.faire.com/fastly/034ddcd72629297d5c62d5d5be9f8a644c70fabc1469a19fb68ba1b210fe5656.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "\nOur best selling JUMBO lip balms are back!\n\nKeep your chapped lips soft and nourished with our Tallow Lip Balm! Crafted from grass-fed beef tallow, this lip balm is known to moisturize, protect and soothe - all at the same time!\n\nIngredients:\n\n100% Grass fed tallow, beeswax, shea butter, organic mango butter, organic orange oil, organic grapefruit oil, organic lime oil, organic lemon oil, rosemary extract\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 9,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:29.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
